import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.array.map";
import _classCallCheck from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
/**
 * header.tsx
 *
 * Forked from reactabular-table version 8.14.0
 * https://github.com/reactabular/reactabular/tree/v8.14.0/packages/reactabular-table/src
 */

import * as React from 'react';
import { ProviderContext } from './provider';
import { HeaderRow } from './header-row';

var BaseHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseHeader, _React$Component);

  var _super = _createSuper(BaseHeader);

  function BaseHeader() {
    _classCallCheck(this, BaseHeader);

    return _super.apply(this, arguments);
  }

  _createClass(BaseHeader, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          headerRows = _a.headerRows,
          onRow = _a.onRow,
          renderers = _a.renderers,
          columns = _a.columns,
          props = __rest(_a, ["children", "headerRows", "onRow", "renderers", "columns"]); // If headerRows aren't passed, default to bodyColumns as header rows


      return React.createElement(renderers.header.wrapper, props, [(headerRows || [columns]).map(function (rowData, rowIndex) {
        return React.createElement(HeaderRow, {
          key: "".concat(rowIndex, "-header-row"),
          renderers: renderers.header,
          onRow: onRow,
          rowData: rowData,
          rowIndex: rowIndex
        });
      })].concat(children));
    }
  }]);

  return BaseHeader;
}(React.Component);

export var Header = function Header(props) {
  return React.createElement(ProviderContext.Consumer, null, function (_ref) {
    var columns = _ref.columns,
        renderers = _ref.renderers;
    return React.createElement(BaseHeader, Object.assign({
      columns: columns,
      renderers: renderers
    }, props));
  });
};